import { create } from 'zustand';
import { ALL_TYPES, ALL_COUNTRIES } from 'src/data';

export const useMapFiltersStore = create((set) => ({

    selectedTypes: ALL_TYPES,
    setSelectedTypes: (types) => set({ selectedTypes: types }),

    selectedCountries: ALL_COUNTRIES.map(c => c.name),
    setSelectedCountries: (countries) => set({ selectedCountries: countries }),

    showFavouritesOnly: false,
    setShowFavouritesOnly: (flag) => set({ showFavouritesOnly: flag }),

    showTravellers: true,
    setShowTravellers: (flag) => set({ showTravellers: flag }),

    showFriendsOnly: false,
    setShowFriendsOnly: (flag) => set({ showFriendsOnly: flag }),

    showRoutes: false,  
    setShowRoutes: (value) => set({ showRoutes: value }),
    
}));
